import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cn from 'classnames';
import { Row, Col } from 'react-bootstrap';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import styles from './mobile.scss';
import GoogleLocation from '../event_components/google_location';
import AttendButton from '../event_components/attend_button';
import AddEventToCalendar from '../event_components/add_to_calendar';
import Details from '../event_components/details';
import { LocaleWrapper } from '../../locale-wrapper';
import CheckoutController from '../event_components/Checkout';
import EventStatus from '../event_components/event_status';
import { attendButtonIsVisible } from './utils';
import TwitchPreviousVideo from '../event_components/twitch-video';
import TicketPurchasing from '../event_components/ticket-purchasing';

function Venue({ event, settings }) {
  return event.get('type') === 'google' ? (
    <GoogleLocation event={event} />
  ) : (
    <Location disableLink event={event} settings={settings} className={styles.venue} />
  );
}
class Mobile extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }
  toggleAttendButton = () => {
    this.props.onResizeComponent();
    this.setState({
      openTicketing: !this.state.openTicketing,
    });
  };
  render() {
    const { settings, event, onResizeComponent } = this.props;

    const showLogo = settings.get('showEventLogo');

    if (event.get('initial_embed') || event.get('is_offline')) {
      return event.get('is_offline') ? (
        <TwitchPreviousVideo settings={settings} event={event} />
      ) : (
        <TicketPurchasing event={event} settings={settings} open />
      );
    }
    return (
      <CheckoutController
        variant="default"
        event={event}
        settings={settings}
        inClassName="checkout-down-top"
        openTicketing={this.state.openTicketing}
        onResizeComponent={onResizeComponent}
        onClose={() => {
          this.setState({
            openTicketing: false,
          });
        }}
      >
        <div className={cn(styles.mobileEvent, 'event', 'stack', styles.stack)}>
          {showLogo && (
            <Row className={styles.mobile} center="xs" middle="xs">
              <Col xs={12} className={styles.logo}>
                <Logo event={event} className={styles.image} settings={settings} />
              </Col>
            </Row>
          )}
          <Row className={cn(styles.mobile, { [styles.titleNoLogo]: !showLogo })} center="xs" middle="xs">
            <Col xs={12}>
              <Title event={event} className={styles.title} settings={settings} />
            </Col>
          </Row>
          <Row className={styles.content} center="xs" middle="xs">
            <Col xs={12}>
              <div className={styles.timeContainer}>
                <Time event={event} settings={settings} className={styles.time} />
              </div>
            </Col>
            {(settings.get('showVenue') || settings.get('showFullAddress')) && (
              <Col xs={12}>
                <Venue event={event} settings={settings} />
              </Col>
            )}
            {settings.get('showEventStatus') && (
              <Col xs={12}>
                <EventStatus event={event} settings={settings} className={styles.center} />
              </Col>
            )}
          </Row>
          <Row>
            <Col xs={12} center="xs" middle="xs" className={styles.center}>
              {settings.get('enableAddToCalendar') && (
                <div className={styles.addCalendar}>
                  <AddEventToCalendar event={event} settings={settings} />
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col xs={12} center="xs" middle="xs" className={styles.center}>
              <Details event={event} settings={settings} className={styles.center} onResizeComponent={onResizeComponent} />
            </Col>
          </Row>

          {attendButtonIsVisible(event, settings) && (
            <AttendButton event={event} settings={settings} className={styles.attendButton} handleButtonClick={this.toggleAttendButton} />
          )}
        </div>
      </CheckoutController>
    );
  }
}

Mobile.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

function MobileContainer({ event, settings, onResizeComponent }) {
  return (
    <LocaleWrapper event={event}>
      {settings.get('removeAttendButton') && !settings.get('removeUrlLink') ? (
        <a href={event.get('url')} target="_blank" rel="noopener noreferrer">
          <Mobile event={event} settings={settings} onResizeComponent={onResizeComponent} />
        </a>
      ) : (
        <Mobile event={event} settings={settings} onResizeComponent={onResizeComponent} />
      )}
    </LocaleWrapper>
  );
}

export default MobileContainer;
